import { render } from "./CardFooter.vue?vue&type=template&id=138d13d0"
import script from "./CardFooter.vue?vue&type=script&lang=js"
export * from "./CardFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__